import React, { useEffect } from 'react';

interface FiltersBottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

const FiltersBottomSheet: React.FC<FiltersBottomSheetProps> = ({ isOpen, onClose, title, children }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="filters-bottom-sheet-overlay" onClick={onClose}>
      <div className="filters-bottom-sheet" onClick={(e) => e.stopPropagation()}>
        <div className="filters-bottom-sheet-header">
          <h3>{title}</h3>
          <button
            type="button"
            className="filters-bottom-sheet-close"
            onClick={onClose}
            aria-label="Закрыть"
          >
            ×
          </button>
        </div>
        <div className="filters-bottom-sheet-content">
          {children}
        </div>
        <div className="filters-bottom-sheet-actions">
          <button type="button" className="primary" onClick={onClose}>
            Применить
          </button>
        </div>
      </div>
    </div>
  );
};

export default FiltersBottomSheet;




